import React from 'react';
import '../scss/theme-dark.scss';
import App from '../screens/Root';

const Theme = () => (<React.Fragment>
    <App />
</React.Fragment>);

export default Theme;